module.exports = __webpack_public_path__ + "static/media/sort-numeric-down-alt.5fab3f80.svg";